import SalesActivityActionCreators from "../../store/actions/SalesActivity";
import { GetOneSaleActivityRequest, ZomentumRoutes } from "@/Contracts";
import { SalesActivity } from "@/Contracts/Others/SalesActivity";
import useRefreshSalesActivity from "./useRefreshSalesActivity";
// import { useLocation } from "react-router-dom";
import {
	SalesActivityModuleState,
	useSalesActivityModuleDispatch,
	useSalesActivityModuleSelector
} from "../../store";
import { useContext } from "react";
import { ParentContext } from "../../store/context/ParentContext";

const useHandleEditSalesActivity = (): ((
	salesActivity: SalesActivity
) => void) => {
	const parentContext = useContext(ParentContext);
	const { currentActiveOpportunity } = parentContext.opportunity;
	const { companyUserList } = parentContext.user;
	const { userAllSalesActivities } = useSalesActivityModuleSelector(
		(state: SalesActivityModuleState) => {
			return {
				userAllSalesActivities:
					state.salesActivity.userAllSalesActivities
			};
		}
	);

	const dispatch = useSalesActivityModuleDispatch();
	// const location = useLocation();

	const refreshSalesActivity = useRefreshSalesActivity();

	const fetchUpdatedOpportunities = (opportunityId?: string) => {
		parentContext.opportunity.syncKanbanOpportunityDataById(
			opportunityId ?? currentActiveOpportunity?.id ?? ""
		);
	};

	const handleEditSalesActivity = async (
		salesActivity: SalesActivity,
		opportunityId?: string
	) => {
		if (
			!!userAllSalesActivities.response.length &&
			window.location.pathname === ZomentumRoutes.SalesActivityPage
		) {
			const activity = await dispatch(
				SalesActivityActionCreators.fetchOneSalesActivity(
					new GetOneSaleActivityRequest(
						salesActivity.id,
						salesActivity.feed_type
					),
					companyUserList
				)
			);
			dispatch(
				SalesActivityActionCreators.updateSingleUsersSalesActivity(
					activity.salesActivity
				)
			);
		} else if (
			window.location.pathname === ZomentumRoutes.OpportunityList ||
			window.location.pathname === ZomentumRoutes.VendorOpportunityList
		) {
			fetchUpdatedOpportunities(opportunityId);
		} else if (
			window.location.pathname.startsWith(
				`${ZomentumRoutes.OpportunityList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.ClientsList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.VendorOpportunityList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.VendorClientList}/`
			) ||
			window.location.pathname.startsWith(
				`${ZomentumRoutes.VendorPartnerList}/`
			)
		) {
			refreshSalesActivity();
		}
	};

	return handleEditSalesActivity;
};

export default useHandleEditSalesActivity;
